import React from 'react';
import { Button, Spin } from 'antd';
import { IAppButtonProps } from 'src/models/Button';
import en from 'src/messages/en.json';

const AntDButton: React.FC<IAppButtonProps> = ({
  status,
  statusOnComplete,
  loading = false,
  onClick,
  disabled = false,
  type = 'default',
  htmlType = 'button',
  style,
  prefixIcon,
  className,
}) => {
  return (
    <Button
      type={type}
      htmlType={htmlType}
      onClick={onClick}
      disabled={disabled || loading}
      style={style}
      icon={prefixIcon}
      className={className}
    >
      {loading ? (
        <span>
          <Spin size="small" />
          {status || en.Common.Title.loading}
        </span>
      ) : (
        statusOnComplete
      )}
    </Button>
  );
};

export default AntDButton;
